var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"56206056"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/rating-frontend";

import getConfig from 'next/config';

import * as Sentry from '@sentry/nextjs';

const { publicRuntimeConfig } = getConfig();
const SENTRY_DSN = publicRuntimeConfig.sentryDSN;
const ENVIRONMENT = publicRuntimeConfig.environment;
// const RELEASE = publicRuntimeConfig.release;

Sentry.init({
  enabled: ENVIRONMENT === 'production',
  environment: ENVIRONMENT,
  dsn: SENTRY_DSN,
  // Adjust this value in production, or use tracesSampler for greater control
  sampleRate: 1,
  tracesSampleRate: 1,
  ignoreErrors: [],
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
